(() => {
  function launchProductImpressions(productCards) {
    const products = Array.from(productCards).map((productCard) => {
      const productScriptTag = productCard.querySelector('[id^="Product-Item-Data-"]');
      let sectionScriptTag = false;
      const sectionTag = productCard.closest('.shopify-section');
      if (sectionTag) sectionScriptTag = sectionTag.querySelector('[id^="Product-List-Data-"]');
  
      return {
        data: productScriptTag ? JSON.parse(productScriptTag.innerHTML) : {},
        section: sectionScriptTag ? JSON.parse(sectionScriptTag.innerHTML) : {}
      };
    });
    
    const items = products.map((product) => ({...product.data, ...product.section}));
  
    /* Push to dataLayer */
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'view_item_list',
      ecommerce: {
        items,
      },
    });
  
    console.log('%cEvent: view_item_list', 'color: #FF9100');
    console.log(window.dataLayer);
  }

  function checkForProducts() {
    const productNodes = document.querySelectorAll('#ProductGridContainer [data-product-card]');
    const productNodesVisible = Array.from(productNodes).filter(element => element.clientWidth > 0)
    if (productNodesVisible.length) {
      launchProductImpressions(productNodesVisible);
    }
  }
  
  document.addEventListener('products:refresh', checkForProducts);
  checkForProducts();
})();
